module.exports = __webpack_public_path__ + "static/img/IMG_20151231_121954.ca9584a4.jpg";